export const postWebviewMessage = (messageId: string, payload: any) => {
  let message = {
    ...{ id: messageId },
    ...payload,
  }

  message = /android/i.test(navigator.userAgent)
    ? JSON.stringify(message)
    : message

  try {
    /* global javascriptMessageHandler
       @ts-ignore */
    if (typeof javascriptMessageHandler !== 'undefined') {
      /* global scope, defined in android DBRent apps 
        @ts-ignore */
      javascriptMessageHandler.postMessage(message)
    } else if (
      typeof window.webkit !== 'undefined' &&
      typeof window.webkit.messageHandlers.JavascriptMessageHandler !==
        'undefined'
    ) {
      window.webkit.messageHandlers.JavascriptMessageHandler.postMessage(
        message,
        location.origin
      )
    } else {
      window.postMessage(message, location.origin)
    }
  } catch (error) {
    window.postMessage(message, location.origin)
  } finally {
    return
  }
}
